import { convertToURL } from 'api/utils/convertToURL';
import axios from 'axios';
import qs from 'qs';

import deduplicator from './utils/deduplicator';

const instance = axios.create();
export const defaultBaseURL = `${process.env.REACT_APP_API_PROTOCOL}//${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}`;

export const api = (template, config = {}) => {
  if (template.split(' ').length !== 2) {
    // eslint-disable-next-line no-console
    console.error(`API declaration ${template} in wrong`);
  }
  return async (data = {}, requestConfig = {}) => {
    const { method, urlPath, getParams } = convertToURL(template, data);

    const { deduplicatorTimeout, ...otherConfig } = requestConfig;
    let axiosConfig = {
      baseURL: defaultBaseURL,
      withCredentials: true,
      paramsSerializer: {
        serialize: (query) => {
          const cloneQuery = { ...query };

          // add square brackkets to identify array with single value
          Object.keys(cloneQuery).forEach((item) => {
            if (
              Array.isArray(cloneQuery[item]) &&
              cloneQuery[item].length === 1 &&
              !item.includes('[]')
            ) {
              cloneQuery[`${item}[]`] = cloneQuery[item];
              delete cloneQuery[item];
            }
          });

          return qs.stringify(cloneQuery, {
            encode: false,
            indices: false,
            arrayFormat: 'comma',
          });
        },
      },
      method: method,
      url: urlPath,
      ...config,
      ...otherConfig,
    };

    if (method === 'GET') {
      axiosConfig.params = getParams;
    }
    if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
      axiosConfig.data = data;
    }

    if (urlPath.includes('field')) {
      let dedupKey = JSON.stringify([method, urlPath, data]);

      return deduplicator(
        dedupKey,
        async () => {
          const { signal: _, ...otherAxiosConfig } = axiosConfig;
          let response = await instance.request(otherAxiosConfig);
          return response.data;
        },
        deduplicatorTimeout
      );
    } else {
      let response = await instance.request(axiosConfig);
      return response.data;
    }
  };
};

export const registerRequestInterceptor = (callback, cause = '') => {
  // eslint-disable-next-line no-console
  // console.debug(`+ [Request Interceptor] ${cause}`);
  const interceptor = instance.interceptors.request.use((config) =>
    callback(config)
  );

  return () => {
    // eslint-disable-next-line no-console
    // console.debug(`- [Request Interceptor] ${cause}`);
    instance.interceptors.request.eject(interceptor);
  };
};

export const registerResponseInterceptor = (callback, cause = '') => {
  // eslint-disable-next-line no-console
  // console.debug(`+ [Response Interceptor] ${cause}`);

  const interceptor = instance.interceptors.response.use((response) =>
    callback(response)
  );

  return () => {
    // eslint-disable-next-line no-console
    // console.debug(`- [Response Interceptor] ${cause}`);
    instance.interceptors.response.eject(interceptor);
  };
};

export const registerErrorInterceptor = (cb, cause = '') => {
  // eslint-disable-next-line no-console
  // console.debug(`+ [Response Error Interceptor] ${cause}`);

  const interceptor = instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      throw await cb(error);
    }
  );

  return () => {
    // eslint-disable-next-line no-console
    // console.debug(`- [Response Error Interceptor] ${cause}`);
    instance.interceptors.response.eject(interceptor);
  };
};
